<!-- Blocking progress: title, bar, steps and percent -->
<div class="overlay" role="alertdialog" aria-busy="true" [attr.aria-label]="title">
  <div class="popup">
    <div class="popup-head">
      <app-spinner [diameter]="22" [iconOnly]="true"></app-spinner>
      <h2>{{ title }}</h2>
    </div>

    @if (percent !== null) {
    <mat-progress-bar mode="determinate" [value]="percent"></mat-progress-bar>

    <p class="popup-meta">
      @if (totalStages) {
      <span>{{ currentStage }} / {{ totalStages }} {{ stageTitle }}</span>
      }
      <span class="percent">{{ percent | number: '1.0-0' }} %</span>
    </p>
    }
  </div>
</div>
